<div class="login-container">
  <mat-card class="card-section">
    <mat-card-title>{{ "Sign in" | translate }}</mat-card-title>
    <mat-card-subtitle
      >{{ "To get access to" | translate }} {{ " " }}
      <strong>{{ appName | translate }},</strong> {{ " " }}
      {{ "please login" | translate }}</mat-card-subtitle
    >
  </mat-card>
</div>
